import styled from 'styled-components'

export const CardActions = styled.div`
  display: flex;
  flex-direction: row-reverse;
  border-top: 1px solid ${(props) => props.theme.greyColor};
  padding: 8px 12px 8px 12px;
`
